import { useDispatch } from "react-redux";
import { postRegisterCampaign } from "../Store/Action";
import { useParams, useNavigate, Link, useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { getWithExpiry } from "@/utils/token";
import { useSelector } from "react-redux";
function FormDetailPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const isFamtour = searchParams.get('isFamtour') === 'true';

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = getWithExpiry("token");
  const dataUser = useSelector(
    (state) => state.ReducerloginUser.loginedUser.data
  );

  if (!token) {
    return (window.location.href = "/login");
  }

  const agreement = [
    "리뷰작성 후 최소 6개월 이상 전체공개 유지",
    "공정위 배너 가이드라인에 따라 필수 삽입",
    "리뷰(이미지 포함) 위유 및 광고주가 활용",
    "당첨자 개인정보의 일부를 체험을 위해 업체에 제공",
    "체험단 상품은 타인에게 양도 및 판매가 불가",
  ];

  const userInfo = getWithExpiry("userInfo");

  const baseFormData = {
    blog: dataUser?.SnsUrl || userInfo?.SnsUrl || "",
    phone: dataUser?.phone || userInfo?.phone || "",
    name: dataUser?.name || userInfo?.name || "",
    user_id: Number(dataUser?.id || userInfo?.id || 0),
    is_agree: [],
  };

  const [formData, setFormData] = useState({
    ...baseFormData,
    ...(isFamtour
      ? { fam_tour_id: Number(id) }
      : { campaign_id: Number(id) }),
  });

  const [isAllAgree, setIsAllAgree] = useState(false);
  const [urlError, setUrlError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked, id } = e.target;

    if (type === "checkbox") {
      let updatedAgreements = [...formData.is_agree];

      if (id === "all") {
        if (checked) {
          updatedAgreements = agreement.map((_, idx) => String(idx));
        } else {
          updatedAgreements = [];
        }
        setIsAllAgree(checked);
      } else {
        if (checked) {
          updatedAgreements.push(id);
        } else {
          updatedAgreements = updatedAgreements.filter((item) => item !== id);
        }
      }

      setFormData({
        ...formData,
        is_agree: updatedAgreements,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let blogUrl = formData.blog.trim();
    if (!/^https?:\/\//i.test(blogUrl)) {
      blogUrl = `https://${blogUrl}`;
    }
    //formdata.blog에 url 이면서 naver, instagram, blog 포함되어 있는지 확인
    const urlRegex =
      /^(https?:\/\/)?(www\.)?naver\.com|instagram\.com|blog\.naver\.com/;
    if (!urlRegex.test(blogUrl)) {
      setUrlError(
        "올바른 SNS 주소를 입력해주세요. 예시: https://blog.naver.com/your_id"
      );
      return;
    } else {
      setUrlError(""); // bersihkan error kalau sudah valid
    }

    if (!token) {
      alert("먼저 로그인하세요!");
      navigate("/login");
      return;
    }

    const finalFormData = {
      ...formData,
      blog: blogUrl,
      is_agree: isAllAgree,
    };

    // console.log("📤 Final Form Data (before dispatch):", finalFormData);

    try {
      await dispatch(postRegisterCampaign(finalFormData, isFamtour));
      // console.log("✅ Dispatch successful:", response.meta);
      alert("신청되었습니다!");
      navigate("/mypage");
    } catch (error) {
      console.error("❌ Error on submit:", error.message || error);
      if (error.message === "session_expired") {
        localStorage.removeItem("token");
        window.location.href = "/login";
      } else if (error.message === "already_subscribe") {
        alert("이미 등록되었습니다.");
        window.location.href = "/";
      } else if (error.message === "not_in_period") {
        alert("기간 중이 아님");
      } else {
        alert("오류가 발생했습니다. 다시 시도해주세요.");
      }
    }
  };

  useEffect(() => {
    scrollTo(0, 0);
    setIsAllAgree(formData.is_agree.length === agreement.length);
  }, [formData.is_agree]);

  return (
    <div className="p-5 lg:w-2/4 lg:mx-auto lg:pt-28">
      <h1 className="font-extrabold text-xl pb-3">신청 양식</h1>
      <hr />
      <form
        className="flex flex-col text-gray-600 gap-3 pt-3"
        onSubmit={handleSubmit}
      >
        <input
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="w-full border px-4 py-3 focus:outline-black rounded"
          placeholder="이름 입력"
          required
        />
        <input
          name="blog"
          value={formData.blog}
          onChange={handleChange}
          type="text"
          className="w-full border px-4 py-3 focus:outline-black rounded"
          placeholder="활동중인 블로그 또는 인스타그램 주소"
          // required
        />
        {urlError && <p className="text-red-500 text-sm mb-1">{urlError}</p>}
        <input
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          className="w-full border px-4 py-3 focus:outline-black rounded"
          placeholder="핸드폰번호"
          required
        />
        <div className="flex gap-3 border-b pb-2 items-center">
          <input
            type="checkbox"
            id="all"
            checked={isAllAgree}
            onChange={handleChange}
            className="border-gray-300 rounded-full focus:outline-none"
          />
          <p className="text-black font-semibold">모두 동의</p>
        </div>
        <div className="font-bold">유의사항 및 개인정보 활용</div>
        {agreement.map((el, idx) => (
          <div key={idx} className="flex items-start gap-2">
            <input
              type="checkbox"
              name="is_agree"
              checked={formData.is_agree.includes(String(idx))}
              onChange={handleChange}
              className="border-gray-300 peer rounded-full focus:outline-none mt-1"
              required
              id={String(idx)}
            />
            <label htmlFor={String(idx)} className="text-black">
              {el}
            </label>
          </div>
        ))}

        {token ? (
          <button
            type="submit"
            className={`py-3 rounded-md ${
              isAllAgree
                ? "bg-[#384D92] text-white"
                : "bg-gray-500 text-white cursor-not-allowed"
            }`}
            disabled={!isAllAgree}
          >
            신청하기
          </button>
        ) : (
          <button
            type="submit"
            disabled
            className="bg-gray-500 text-white py-3 rounded-md"
          >
            신청하기
          </button>
        )}
        {token ? null : (
          <Link to="/login">
            <p className="underline text-red-500 text-center">
              먼저 로그인하세요
            </p>
          </Link>
        )}
      </form>
    </div>
  );
}

export default FormDetailPage;
